var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    _vm._g(
      {
        class: ["user", _vm.nickColor, { active: _vm.active }],
        attrs: { "data-name": _vm.user.nick, role: "button" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.openContextMenu.apply(null, arguments)
          },
          contextmenu: function ($event) {
            $event.preventDefault()
            return _vm.openContextMenu.apply(null, arguments)
          },
        },
      },
      _vm.onHover ? { mouseenter: _vm.hover } : {}
    ),
    [
      _vm._t("default", function () {
        return [_vm._v(_vm._s(_vm.mode) + _vm._s(_vm.user.nick))]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }